import React from "react";
import OrderSelector from "./OrderSelector";

/**
 * SubCategoryOrderSelector Component
 * Wrapper for OrderSelector configured for subcategories
 */
export default function SubCategoryOrderSelector({
  brandColor,
  title,
  searchPlaceholder,
}) {
  return (
    <OrderSelector
      type="subcategory"
      brandColor={brandColor}
      title={title}
      searchPlaceholder={searchPlaceholder}
      itemIcon="subcategory"
    />
  );
}
